module.exports = __webpack_public_path__ + "img/bubble_ads.6023f9f2.png";